import { ContactMe } from '../types';
import { contactMe } from '../data/portfolioData';

// import datoCMSClient from './datoCMSClient';

export async function getContactMe(): Promise<ContactMe> {
  return contactMe;
}
